import { Outlet } from "react-router-dom";

const Patients = () => {
  return (
    <div className="h-screen w-full">
      <Outlet />
    </div>
  );
};

export default Patients;
